import clx from 'classnames';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';

const StyledLoginBlock = styled.div`
  &.right {
    padding-left: 12px;
    ${down('md')} {
      padding-left: 0;
    }
  }
  &.left {
    border-right: 1px solid #f0f0f0;
    padding-right: 12px;
    ${down('md')} {
      padding-right: 0;
      border-right: none;
    }
  }
  a {
    text-decoration: underline;
  }
  /* ${down('xl')} {
    padding-bottom: 24px;
  } */
  ${down('sm')} {
    /* padding-bottom: 48px; */
  }
`;
const FirstBlock = styled.div`
  min-height: 154px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ${down('xl')} {
    min-height: 154px;
  }
  ${down('lg')} {
    min-height: 138px;
  }
  ${down('md')} {
    min-height: unset;
  }
`;
const ButtonBlock = styled.div`
  padding: 20px 0;
`;

export interface ILoginBlockProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  hasBackground?: boolean;
  before?: React.ReactNode;
  after?: React.ReactNode;
  link?: React.ReactNode;
  button?: React.ReactNode;
  right?: boolean;
  left?: boolean;
}
/**
 * Form di login all'applicativo, tramite le API di creazione AccessToken JWT.
 */
export function LoginBlock(props: ILoginBlockProps) {
  const { before, link, after, button, right, left, ...divProps } = props;

  return (
    <StyledLoginBlock {...divProps} className={clx({ right, left })}>
      <FirstBlock>
        {before}
        {link}
      </FirstBlock>
      {button && <ButtonBlock>{button}</ButtonBlock>}
      <div>{after}</div>
    </StyledLoginBlock>
  );
}
